export default {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"
  siteTitle: 'SARAH WEISMAN', // Navigation and Site Title
  siteTitleAlt: 'SARAH WEISMAN - Artist and Sculptor from Berlin, Paris', // Alternative Site title for SEO
  siteUrl: 'https://sarahweisman.de', // Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  siteBanner: '/assets/banner.jpg', // Your image for og:image tag. You can find it in the /static folder
  favicon: 'src/favicon.png', // Your image for favicons. You can find it in the /src folder
  siteBrand: 'Sarah<br>Weisman',
  siteDescription: `Prof. Sarah Weisman, born Esser 1977 in Münster, lives as an artist and sculptor in Berlin and teaches at the Trier University of Applied Sciences. As a „Meisterschülerin“ of Prof. Berndt Wilde (Kunsthochschule Berlin) she received several prizes and scholarships in Europe. Her oeuvre comprises more than 100 sculptures, drawings and watercolors.`, // Your site description
  author: 'Prof. Sarah Weisman, born Esser', // Author for schemaORGJSONLD
  siteLogo: '/assets/logo.png', // Image for schemaORGJSONLD

  allowedWorkExtensions: ['jpg', 'jpeg', 'png'],

  // siteFBAppID: '123456789', // Facebook App ID - Optional
  userTwitter: '', // Twitter Username - Optional
  ogSiteName: '', // Facebook Site Name - Optional
  ogLanguage: '', // Facebook Language

  // Manifest and Progress color
  // See: https://developers.google.com/web/fundamentals/web-app-manifest/
  themeColor: '#3498DB',
  backgroundColor: '#FFF',

  // Settings for typography.ts
  headerFontFamily: 'Roboto Mono',
  bodyFontFamily: 'Roboto',
  baseFontSize: '18px',

  // Header
  headerHeightRatio: 2,
  footerHeightRatio: 2,

  // Grid Gutter
  gridGutter: 1, // rem
  gridColumns: 12,

  defaultColumnsLeft: 2,
  defaultColumnsRight: 10,
};
